module.exports = {"430421100":"西渡镇","430421101":"集兵镇","430421103":"杉桥镇","430421104":"井头镇","430421105":"演陂镇","430421106":"金兰镇","430421107":"洪市镇","430421108":"曲兰镇","430421109":"金溪镇","430421110":"界牌镇","430421111":"渣江镇","430421112":"三湖镇","430421113":"台源镇","430421114":"关市镇","430421115":"库宗桥镇","430421116":"岘山镇","430421117":"石市镇","430421200":"樟木乡","430421201":"岣嵝乡","430421205":"栏垅乡","430421207":"大安乡","430421208":"溪江乡","430421210":"长安乡","430421211":"板市乡","430421212":"樟树乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430421.json
// module id = 1680
// module chunks = 0